import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { CallToActionComponent } from "@hermes/aphrodite/call-to-action";

import { RegisterYourInterestStateModule } from "@hermes/states/register-your-interest";

import { CallToActionRegisterYourInterestComponent } from "./call-to-action-register-your-interest.component";

@NgModule({
    imports: [
        CommonModule,
        CallToActionComponent,
        RegisterYourInterestStateModule,
    ],
    declarations: [CallToActionRegisterYourInterestComponent],
    exports: [CallToActionRegisterYourInterestComponent],
})
export class CallToActionRegisterYourInterestModule {}
